import React from "react";
import Carousel from "react-bootstrap/Carousel";
import ScrollDown from "../scroll-down/scroll-down";

import "./carousel.css";

import MedSlide1 from "../../assets/img/carousel/med_slide1.jpg";
import MedSlide2 from "../../assets/img/carousel/med_slide2.jpg";
import MedSlide3 from "../../assets/img/carousel/med_slide3.jpg";

const CustomCarousel = () => {
  return (
    <div id="home">
      <Carousel controls={false} indicators interval={2500} pause={false}>
        <Carousel.Item>
          <img
            className="d-block w-100 custom-img "
            src={MedSlide1}
            alt="First slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 custom-img "
            src={MedSlide2}
            alt="Second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 custom-img "
            src={MedSlide3}
            alt="Third slide"
          />
        </Carousel.Item>
      </Carousel>
      <ScrollDown />
    </div>
  );
};

export default CustomCarousel;
